<template>
  <section>
    <v-dialog v-model="dialogConfirm" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h6 text-center w-100">ส่งโพยสำเร็จ</span>
        </v-card-title>
        <v-card-text>
          <v-container class="p-0">
            <v-row>
              <v-col cols="4">
                <v-btn
                  color="red darken-1 w-100 text-white"
                  @click="redirectgame()"
                >
                  แทงหวย
                </v-btn>
              </v-col>
              <v-col cols="4">
                <v-btn
                  color="blue darken-1 w-100 text-white"
                  @click="redirectpage()"
                >
                  ดูโพย
                </v-btn>
              </v-col>
              <v-col cols="4">
                <v-btn
                  color="green darken-1 w-100 text-white"
                  @click="reload()"
                >
                  เล่นต่อ
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div class="col-12 text-xl text-primary text-center py-0">
      <countdown
        v-if="secondsLeft > 0"
        :text-position="`text-center`"
        type-countdown="lotto"
        :seconds-left="secondsLeft"
        @game-timeout="gameTimeout"
      />
    </div>
    <b-modal id="bv-modal-rule" centered size="xl" hide-footer>
      <template #modal-title> กติกา {{ gameMasterName }}<br /> </template>
      <div class="d-block text-center">
        <div class="card-body mt-0 px-1 py-0 text-center">
          <iframe id="iframe" :src="ruleUrl" />
        </div>
      </div>
      <div class="d-flex">
        <div class="flex-width mx-1">
          <b-button
            class="mt-3 btn-danger w-100"
            block
            @click="$bvModal.hide('bv-modal-rule')"
          >
            ปิด
          </b-button>
        </div>
      </div>
    </b-modal>
    <div v-if="currentGameStatus == 'open'" class="w-100">
      <div
        v-if="
          gameMasterSlug == 'soidown_5' ||
          gameMasterSlug == 'soidown' ||
          gameMasterSlug == 'soidown_15' ||
          gameMasterSlug == 'soidown_vip'
        "
        class="row"
      >
        <!-- Using value -->
        <div
          v-for="(buttonsActionItem, index) in buttonsActions"
          :key="buttonsActionItem.index"
          class="col-4 col-lg-5 mb-3"
        >
          <button
            class="w-100 btn btn-outline-dark text-lg"
            :class="{
              active: containsBetOrShoot(candidatesBetOrShoot, index),
            }"
            type="button"
            @click="provideBetOrShoot(buttonsActionItem, index)"
          >
            {{ buttonsActionItem.name }}
          </button>
        </div>
        <div class="col-4 col-lg-2 mb-3">
          <button v-b-modal.bv-modal-rule class="btn btn-dark w-100 text-lg">
            กติกา
          </button>
        </div>
      </div>
      <div v-else class="row">
        <div class="col-6 col-lg-10 mb-3">
          <button
            class="w-100 btn btn-outline-dark text-lg py-3"
            :class="{
              active: containsBetOrShoot(candidatesBetOrShoot, 0),
            }"
            type="button"
            @click="provideBetOrShoot(buttonsActionItem, 0)"
          >
            แทงเลข
          </button>
        </div>
        <div class="col-6 col-lg-2 mb-3">
          <button
            v-b-modal.bv-modal-rule
            class="btn btn-dark w-100 text-lg py-3"
          >
            กติกา
          </button>
        </div>
      </div>

      <div
        v-if="betOrShoot == 0 && secondsLeft > 0"
        class="row justify-content-center mb-3 mt-3"
      >
        <div
          v-if="!gameMasterSlug.startsWith('step_')"
          class="col-12 mb-3 text-left"
        >
          <div class="card shadow-sm w-100">
            <div
              class="card-header bg-primary d-flex justify-content-between text-white py-2"
            >
              <span>เลือกรูปแบบ</span>
            </div>
            <div class="card-body row">
              <div
                v-for="(acceptant, index) in accepTantsTemp"
                :key="acceptant.index"
                class="col-6 px-1 mb-2"
              >
                <button
                  class="w-100 btn btn-pink-custom py-2"
                  :class="{
                    active: containsBetType(candidatesBetType, acceptant.slug),
                  }"
                  type="button"
                  @click="provideBetType(acceptant, index, acceptant.slug)"
                >
                  {{ acceptant.display }}
                  <br class="d-lg-none" />(
                  {{
                    Intl.NumberFormat("en-US").format(
                      acceptant.default_pay_rate
                    )
                  }}
                  )
                </button>
              </div>
            </div>
          </div>
        </div>
        <span v-if="!gameMasterSlug.startsWith('step_')" class="w-100 d-flex">
          <div
            v-for="(buttonTypeItem, index) in buttonsTypes"
            :key="buttonTypeItem.index"
            class="col-6 mb-3"
          >
            <button
              class="w-100 btn btn-pink-custom text-lg py-3"
              :class="{
                active: containsButtonType(candidatesButtonType, index),
              }"
              type="button"
              @click="provideButtonType(buttonTypeItem, index)"
            >
              {{ buttonTypeItem.name }}
            </button>
          </div>
        </span>

        <bet-set
          v-if="
            betOrShoot == 0 &&
            secondsLeft > 0 &&
            gameMasterSlug.startsWith('step_')
          "
          :lotto-numbers-with-type="lottoNumbersWithType"
          @child-digitClickSet="digitClickSet"
        />
        <div
          v-if="
            betOrShoot == 0 &&
            secondsLeft > 0 &&
            !gameMasterSlug.startsWith('step_')
          "
          class="col-12 col-lg-7 col-xl-8 mb-3"
        >
          <div class="card shadow-sm">
            <div v-if="buttonSelectType == 0" class="card-body">
              <bet-button-group
                :special-rate="specialRate"
                :url-api-lotto-rate="urlApiLottoRate"
                :digit-type="candidatesBetType"
                :lotto-numbers-with-type="lottoNumbersWithType"
                :accep-tants="acceptants"
                @child-digitClick="digitClick"
                @child-digitShuffleClick="digitClick"
                @child-digitClickSpecial="digitClickSpecial"
              />
            </div>
            <div v-else class="card-body px-2">
              <pick-digit
                :lotto-numbers-with-type="lottoNumbersWithType"
                :url-api-lotto-rate="urlApiLottoRate"
                :digit-type="candidatesBetType"
                :accep-tants="acceptants"
                @child-digitClick="digitClick"
              />
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-5 col-xl-4 mb-3">
          <lotto-review
            :game-id="gameId"
            :game-master-id="gameMasterId"
            :url-api-lotto-template="urlApiLottoTemplate"
            :url-api-get-template="urlApiGetTemplate"
            :url-api-del-template="urlApiDelTemplate"
            :url-api-lotto-rate="urlApiLottoRate"
            :game-master-name="gameMasterName"
            :game-master-slug="gameMasterSlug"
            :url-api-lotto-bet="urlApiLottoBet"
            :accep-tants="acceptants"
            :game-limitations="gameLimitation"
            :lotto-numbers-with-type="lottoNumbersWithType"
            @child-templateClick="templateClick"
            @child-digitClickReview="digitClickReview"
            @child-resetLottoNumbersWithType="resetLottoNumbersWithType"
            @child-emptyLottoNumbersWithType="emptyLottoNumbersWithType"
            @child-updateLottoWithType="updateLottoWithType"
            @child-digitClickSpecial="digitClickSpecial"
          />
          <div class="card mt-3">
            <div class="card-header d-flex align-items-center">
              <div class="flex-width text-left">เลขอั้น / เลขพิเศษ</div>
            </div>
            <div class="card-body">
              <div
                v-for="(specialRateEntrie, index) in specialRateEntries"
                :key="specialRateEntrie.index"
              >
                <div v-if="specialRateEntrie.special_rate.length > 0">
                  <h4 class="text-md text-left py-0 mt-2">
                    {{ specialRateEntrie.display }}
                  </h4>
                  <p
                    v-for="(special_rate, index) in sortedArray(
                      specialRateEntrie.special_rate
                    )"
                    v-if="special_rate.type == 'special'"
                    :key="special_rate.index"
                    class="text-md text-left text-monospace my-0 py-1"
                  >
                    <font v-if="special_rate.rate_percent > 100">
                      เลขพิเศษ
                    </font>
                    <font v-else> เลขอั้น </font>
                    |
                    {{ special_rate.digits }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="card mt-3">
            <div class="card-header">
              <h4>เงือนไขการแทง</h4>
            </div>
            <div class="card-body">
              <div v-for="gamelimit in gameLimitation">
                <div
                  v-if="gamelimit.slug == 'any_upper'"
                  class="text-left w-100 text-xl my-1"
                >
                  วิ่งบน
                </div>
                <div
                  v-else-if="gamelimit.slug == 'any_under'"
                  class="text-left w-100 text-xl my-1"
                >
                  วิ่งล่าง
                </div>
                <div
                  v-else-if="gamelimit.slug == '2upper'"
                  class="text-left w-100 text-xl my-1"
                >
                  สองตัวบน
                </div>
                <div
                  v-else-if="gamelimit.slug == '2under'"
                  class="text-left w-100 text-xl my-1"
                >
                  สองตัวล่าง
                </div>
                <div
                  v-else-if="gamelimit.slug == '3upper'"
                  class="text-left w-100 text-xl my-1"
                >
                  สามตัวตรง
                </div>
                <div
                  v-else-if="gamelimit.slug == '3shuffle'"
                  class="text-left w-100 text-xl my-1"
                >
                  สามตัวโต๊ด
                </div>
                <div
                  v-else-if="gamelimit.slug == '3front'"
                  class="text-left w-100 text-xl my-1"
                >
                  สามตัวหน้า
                </div>
                <div
                  v-else-if="gamelimit.slug == '3back'"
                  class="text-left w-100 text-xl my-1"
                >
                  สามตัวหลัง
                </div>

                <div class="w-100 text-left text-lg">
                  แทงขั้นต่ำต่อเลข : {{ gamelimit.minimum }}
                </div>
                <div class="w-100 text-left text-lg">
                  แทงสูงสุดต่อเลข : {{ gamelimit.maximum }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="w-100">
      <div class="col-12 p-0 mb-3">
        <button
          v-b-modal.bv-modal-rule
          class="btn btn-dark w-100 text-lg py-3 px-0"
        >
          กติกา
        </button>
      </div>
      <div class="card">
        <div
          class="card-header text-center"
          :class="changeClass(currentGameStatus)"
        >
          {{ changeTitle(currentGameStatus) }}
        </div>

        <div
          v-if="
            gameMasterSlug != 'lotto_thai' &&
            gameMasterSlug.search('step_') == -1
          "
          class="card-bory py-2"
        >
          <div class="d-flex">
            <div class="flex-width text-center border-right">
              <small class="text-md">สามตัวบน</small>
            </div>
            <div class="flex-width text-center">
              <small class="text-md">สองตัวล่าง</small>
            </div>
          </div>
          <div
            v-if="gameResults.length > 0"
            class="d-flex text-xxl text-monospace"
          >
            <div
              v-for="result in gameResults"
              v-if="result.result_key == '3upper'"
              class="flex-width text-center border-right"
            >
              {{ result.result_value }}
            </div>
            <div
              v-for="result in gameResults"
              v-if="result.result_key == '2under'"
              class="flex-width text-center"
            >
              {{ result.result_value }}
            </div>
          </div>
          <div v-else class="d-flex text-xxl">
            <div class="flex-width text-center border-right">รอผล</div>
            <div class="flex-width text-center">รอผล</div>
          </div>
        </div>
        <div v-if="gameMasterSlug.search('step_') != -1" class="card-bory py-2">
          <div class="d-flex">
            <div class="flex-width text-center">
              <small class="text-md">สี่ตัวบน</small>
            </div>
          </div>
          <div
            v-if="gameResults.length > 0"
            class="d-flex text-xxl text-monospace"
          >
            <div
              v-for="result in gameResults"
              v-if="result.result_key == '4upper'"
              class="flex-width text-center border-right"
            >
              {{ result.result_value }}
            </div>
          </div>
          <div v-else class="d-flex text-xxl">
            <div class="flex-width text-center">รอผล</div>
          </div>
        </div>
        <div v-if="gameMasterSlug == 'lotto_thai'" class="card-bory py-2">
          <div class="d-flex">
            <div class="flex-width text-center">
              <small class="text-md">รางวัลที่ 1</small>
            </div>
          </div>
          <div
            v-if="gameResults.length > 0"
            class="d-flex border-bottom mb-3 pb-3"
          >
            <div
              v-for="result in gameResults"
              v-if="result.result_key == '1st_prise'"
              class="flex-width text-center"
            >
              {{ result.result_value }}
            </div>
          </div>
          <div v-else class="d-flex border-bottom mb-3 pb-3">
            <div class="flex-width text-center">รอผล</div>
          </div>
          <div class="d-flex">
            <div class="flex-width text-center">
              <small class="text-md">สามตัวหน้า</small>
            </div>
            <div class="flex-width text-center border-left border-right">
              <small class="text-md">สามตัวหลัง</small>
            </div>
            <div class="flex-width text-center">
              <small class="text-md">2ตัวล่าง</small>
            </div>
          </div>
          <div v-if="gameResults.length > 0" class="d-flex">
            <div class="flex-width text-center">
              <span
                v-for="result in gameResults"
                v-if="result.result_key == '3digit_front_1'"
              >
                {{ result.result_value }}
              </span>
              ,
              <span
                v-for="result in gameResults"
                v-if="result.result_key == '3digit_front_2'"
              >
                {{ result.result_value }}
              </span>
            </div>
            <div class="flex-width text-center border-left border-right">
              <span
                v-for="result in gameResults"
                v-if="result.result_key == '3digit_back_1'"
              >
                {{ result.result_value }}
              </span>
              ,
              <span
                v-for="result in gameResults"
                v-if="result.result_key == '3digit_back_2'"
              >
                {{ result.result_value }}
              </span>
            </div>
            <div class="flex-width text-center">
              <span
                v-for="result in gameResults"
                v-if="result.result_key == '2digit'"
              >
                {{ result.result_value }}
              </span>
            </div>
          </div>
          <div v-else class="d-flex">
            <div class="flex-width text-center">
              <span> รอผล </span>
            </div>
            <div class="flex-width text-center border-left border-right">
              <span> รอผล </span>
            </div>
            <div class="flex-width text-center">
              <span> รอผล </span>
            </div>
          </div>
        </div>

        <small
          v-if="
            gameMasterSlug == 'soidown' ||
            gameMasterSlug == 'soidown_5' ||
            gameMasterSlug == 'soidown_15' ||
            gameMasterSlug == 'soidown_vip'
          "
          class="text-red text-center py-1"
          >*เนื่องจากข้อมูลเป็นการแสดงผลแบบใกล้เคียง realtime
          ดังนั้นให้ยึดผลจากเว็บได้คำนวนเสร็จแล้วเป็นหลัก</small
        >
      </div>
    </div>
    <div class="w-100 mt-6">
      <div
        v-if="
          betOrShoot == 1 &&
          (gameMasterSlug == 'soidown_5' ||
            gameMasterSlug == 'soidown' ||
            gameMasterSlug == 'soidown_15' ||
            gameMasterSlug == 'soidown_vip')
        "
        class="row justify-content-center mb-3"
      >
        <div class="col-12 mb-3">
          <div class="card shadow-sm">
            <div class="card-header text-left bg-primary text-white">
              ผลรวมปัจจุบัน
            </div>

            <div class="card-body">
              <h1 class="text-center text-monospace text-xxl">
                ผลรวมเลขยิง<br />
                <!-- {{ parseInt(shootResult) }} -->
                {{ parseInt(shootResult)-parseInt(shootWinFirstDigit)+ parseInt(shootWinSecondDigit)}}
              </h1>
              <div class="d-flex justify-content-between p-2 border-bottom">
                <span
                  class="flex-width text-xl text-uppercase text-success text-left"
                  >อันดับที่ 1 <br class="d-lg-none" />ใช้ในการ บวก</span
                >
                <span
                  class="flex-width text-monospace text-xl text-uppercase text-success text-right"
                  >{{ shootWinFirstDigit }} |<br class="d-lg-none" />
                  {{ shootWinFirst }}</span
                >
              </div>
              <div class="d-flex justify-content-between p-2">
                <span
                  class="flex-width text-xl text-uppercase text-primary text-left"
                  >อันดับที่ 16 <br class="d-lg-none" />ใช้ในการ ลบ</span
                >
                <span
                  class="flex-width text-monospace text-xl text-uppercase text-primary text-right"
                  >{{ shootWinSecondDigit }} |<br class="d-lg-none" />
                  {{ shootWinSecond }}</span
                >
              </div>
              <h1
                v-if="currentGameStatus == 'complete'"
                class="text-center text-monospace text-xxl"
              >
                เลขที่ใช้ออกรางวัล<br /><br />{{
                  parseInt(shootResult)
                }}
                <br /><br />
                <span class="text-red"
                  >*ยึดเป็นตัวเลขสิ้นสุดในการออกผลรางวัล</span
                >
              </h1>
            </div>
          </div>
        </div>
        <shoot
          v-if="currentGameStatus == 'open' || currentGameStatus == 'closed'"
          :url="url"
          :game-id="gameId"
          :user-id="userId"
          :game-master-id="gameMasterId"
        />
        <shoot-list
          :game-id="gameId"
          :game-master-id="gameMasterId"
          @child-statusUpdate="statusUpdate"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { BButton, BModal, VBModal } from "bootstrap-vue";
import { orderBy as _orderBy } from "lodash";

export default {
  name: "SoidownPage",
  components: {
    BButton,
    BModal,
  },
  directives: {
    "b-modal": VBModal,
  },
  props: {
    gameLimitation: {
      type: Array,
      required: true,
    },
    secondsLeft: {
      type: Number,
      default: "",
    },
    gameStatus: {
      type: String,
      default: "",
    },
    gameResults: {
      type: Array,
      required: true,
    },
    ruleUrl: {
      type: String,
      default: "",
    },
    url: {
      type: String,
      default: "",
    },
    urlApiLottoBet: {
      type: String,
      default: "",
    },
    urlApiLottoRate: {
      type: String,
      default: "",
    },
    urlTicket: {
      type: String,
      default: "",
    },
    urlApiLottoTemplate: {
      type: String,
      default: "",
    },
    urlApiDelTemplate: {
      type: String,
      default: "",
    },
    urlApiGetTemplate: {
      type: String,
      default: "",
    },
    gameId: {
      type: Number,
      default: "",
    },
    userId: {
      type: Number,
      default: "",
    },
    gameMasterId: {
      type: Number,
      default: "",
    },
    gameMasterSlug: {
      type: String,
      default: "",
    },
    acceptants: {
      type: Array,
      required: true,
    },
    gameMasterName: {
      default: "",
    },
    gameId: {
      type: Number,
      default: "",
    },
  },
  data() {
    return {
      specialRate: [],
      accepTantsTemp: this.acceptant,
      showModal: false,
      dialogConfirm: false,
      buttonsActions: [
        {
          name: "แทงเลข",
        },
        {
          name: "ยิงเลข",
        },
      ],
      buttonsTypes: [
        {
          name: "เลือกเลข",
        },
        {
          name: "ระบุเลข",
        },
      ],
      render: true,
      acceptantsWithPayRate: [],
      candidatesBetOrShoot: [],
      candidatesBetType: [],
      candidatesButtonType: [],
      betOrShoot: 0,
      betType: "any",
      buttonSelectType: 0,
      shootResult: 0,
      shootWinFirst: "",
      shootWinSecond: "",
      shootWinFirstDigit: "",
      shootWinSecondDigit: "",
      currentGameStatus: this.gameStatus,
      lottoNumbers: [],
      lottoNumbersWithType: [],
      rateKeys: [],
      rateValues: [],
      rateEntries: [],
      specialRateEntries: [],
    };
  },
  computed: {},
  watch: {
    updateData() {
      this.$set(this, "lottoNumbersWithType", data);
    },
  },

  mounted() {
    this.acceptants.sort((a, b) => a.sort - b.sort);

    this.accepTantsTemp = this.acceptants;
    this.candidatesBetOrShoot.push(0);
    this.candidatesButtonType.push(0);

    if (this.secondsLeft <= 0) {
      this.betOrShoot = 1;
    }

    self = this;
    axios
      .get(this.urlApiLottoRate, {
        game_id: this.gameId,
      })
      .then((response) => {
        self.$set(self, "specialRateEntries", response.data);
        self.getRateKey(Object.entries(response.data));
      });
    Echo.join(`lotto-game.${this.gameId}`).listen(
      "rate-changed",
      (response) => {
        self.getRateKey(Object.entries(response.data));
      }
    );
  },

  methods: {
    _orderBy,
    changeClass(data) {
      switch (data) {
        case "closed":
          return "bg-primary text-white";
        case "open":
          return "bg-primary text-white";
        case "complete":
          return "bg-success text-white";
        case "calculating":
          return "bg-primary text-white";
        case "pending":
          return "bg-gray-500 text-white";
        case "cancel":
          return "bg-gray-500 text-white";
      }
    },
    changeTitle(data) {
      switch (data) {
        case "closed":
          return "จบเกมส์";
        case "open":
          return "เปิดรับแทง";
        case "complete":
          return "ผลรางวัล";
        case "calculating":
          return "คำนวณผลรางวัล";
        case "pending":
          return "ปิดรับแทง";
        case "cancel":
          return "เกมส์ยกเลิก";
      }
    },
    redirectpage() {
      window.location.href = this.urlTicket;
    },
    redirectgame() {
      window.location.href = "../lotto";
    },
    reload() {
      window.location.reload();
    },
    gameTimeout(data) {
      this.currentGameStatus = "closed";
      this.changeTitle(this.currentGameStatus);
      this.changeClass(this.currentGameStatus);
      if (
        this.gameMasterSlug == "soidown" ||
        this.gameMasterSlug == "soidown_5" ||
        this.gameMasterSlug == "soidown_15" ||
        this.gameMasterSlug == "soidown_vip"
      ) {
        this.betOrShoot = 1;
        this.candidatesBetOrShoot.push(1);
      }
    },
    getMinimum(slug) {
      const limitation = this.gameLimitation.filter((e) => e.slug == slug);
      return Math.round(limitation[0].minimum);
    },
    openRule(e) {
      const openModal = this.$bvModal.show("bv-modal-rule");
    },
    sortedArray(arrays) {
      return _orderBy(arrays, "digits", "asc");
    },
    resetLottoNumbersWithType() {
      this.$set(this, "dialogConfirm", true);
    },

    emptyLottoNumbersWithType() {
      this.$set(this, "lottoNumbersWithType", []);
    },

    updateLottoWithType(data) {
      this.$set(this, "lottoNumbersWithType", data);
    },

    digitClickReview(data) {
      this.lottoNumbersWithType.splice(data.index, 1);
      Vue.$toast.open({
        message: `ลบเลข ${data.digits} สำเร็จ`,
        type: "error",
        duration: 1000,
        position: "top-right",
      });
    },

    templateClick(data) {
      this.lottoNumbersWithType.push({
        type: data[1],
        digits: data[0],
        amount: data[2],
        paybaht: this.calPayRate(data[1], data[0]),
      });
    },
    digitClick(val) {
      if (val) {
        if (this.candidatesBetType.length == 1) {
          const bettype0 = this.candidatesBetType[0];
          const filters0 = this.lottoNumbersWithType.filter(
            (e) => e.digits == val && e.type == bettype0
          );
          switch (this.candidatesBetType[0]) {
            case "any_upper":
              if (filters0.length <= 0) {
                this.lottoNumbersWithType.push({
                  type: "any_upper",
                  digits: val,
                  amount: this.getMinimum("any_upper"),
                  paybaht: this.calPayRate("any_upper", val),
                });
              } else {
                const index = this.lottoNumbersWithType.findIndex(
                  (x) => x.type === "any_upper" && x.digits === val
                );
                this.lottoNumbersWithType.splice(index, 1);
              }
              break;
            case "any_under":
              if (filters0.length <= 0) {
                this.lottoNumbersWithType.push({
                  type: "any_under",
                  digits: val,
                  amount: this.getMinimum("any_under"),
                  paybaht: this.calPayRate("any_under", val),
                });
              } else {
                const index = this.lottoNumbersWithType.findIndex(
                  (x) => x.type === "any_under" && x.digits === val
                );
                this.lottoNumbersWithType.splice(index, 1);
              }
              break;
            case "2upper":
              if (filters0.length <= 0) {
                this.lottoNumbersWithType.push({
                  type: "2upper",
                  digits: val,
                  amount: this.getMinimum("2upper"),
                  paybaht: this.calPayRate("2upper", val),
                });
              } else {
                const index = this.lottoNumbersWithType.findIndex(
                  (x) => x.type === "2upper" && x.digits === val
                );
                this.lottoNumbersWithType.splice(index, 1);
              }
              break;
            case "2under":
              if (filters0.length <= 0) {
                this.lottoNumbersWithType.push({
                  type: "2under",
                  digits: val,
                  amount: this.getMinimum("2under"),
                  paybaht: this.calPayRate("2under", val),
                });
              } else {
                const index = this.lottoNumbersWithType.findIndex(
                  (x) => x.type === "2under" && x.digits === val
                );
                this.lottoNumbersWithType.splice(index, 1);
              }
              break;
            case "3upper":
              if (filters0.length <= 0) {
                this.lottoNumbersWithType.push({
                  type: "3upper",
                  digits: val,
                  amount: this.getMinimum("3upper"),
                  paybaht: this.calPayRate("3upper", val),
                });
              } else {
                const index = this.lottoNumbersWithType.findIndex(
                  (x) => x.type === "3upper" && x.digits === val
                );
                this.lottoNumbersWithType.splice(index, 1);
              }
              break;
            case "3shuffle":
              if (filters0.length <= 0) {
                this.lottoNumbersWithType.push({
                  type: "3shuffle",
                  digits: val,
                  amount: this.getMinimum("3shuffle"),
                  paybaht: this.calPayRate("3shuffle", val),
                });
              } else {
                const index = this.lottoNumbersWithType.findIndex(
                  (x) => x.type === "3shuffle" && x.digits === val
                );
                this.lottoNumbersWithType.splice(index, 1);
              }
              break;
            case "3back":
              if (filters0.length <= 0) {
                this.lottoNumbersWithType.push({
                  type: "3back",
                  digits: val,
                  amount: this.getMinimum("3back"),
                  paybaht: this.calPayRate("3back", val),
                });
              } else {
                const index = this.lottoNumbersWithType.findIndex(
                  (x) => x.type === "3back" && x.digits === val
                );
                this.lottoNumbersWithType.splice(index, 1);
              }
              break;
            case "3front":
              if (filters0.length <= 0) {
                this.lottoNumbersWithType.push({
                  type: "3front",
                  digits: val,
                  amount: this.getMinimum("3front"),
                  paybaht: this.calPayRate("3front", val),
                });
              } else {
                const index = this.lottoNumbersWithType.findIndex(
                  (x) => x.type === "3front" && x.digits === val
                );
                this.lottoNumbersWithType.splice(index, 1);
              }
              break;
          }
        }
        if (this.candidatesBetType.length == 2) {
          const countDigit = this.lottoNumbersWithType.filter(
            (e) => e.digits == val
          );
          if (countDigit.length == 1) {
            const fillterCurentType = this.candidatesBetType.filter(
              (e) => e.type == countDigit[0].type
            );
            if (fillterCurentType.length == 1) {
              switch (countDigit[0].type) {
                case "any_upper":
                  this.lottoNumbersWithType.push({
                    type: "any_under",
                    digits: val,
                    amount: this.getMinimum("any_under"),
                    paybaht: this.calPayRate("any_under", val),
                  });
                  break;
                case "any_under":
                  this.lottoNumbersWithType.push({
                    type: "any_upper",
                    digits: val,
                    amount: this.getMinimum("any_upper"),
                    paybaht: this.calPayRate("any_upper", val),
                  });
                  break;
                case "2upper":
                  this.lottoNumbersWithType.push({
                    type: "2under",
                    digits: val,
                    amount: this.getMinimum("2under"),
                    paybaht: this.calPayRate("2under", val),
                  });
                  break;
                case "2under":
                  this.lottoNumbersWithType.push({
                    type: "2upper",
                    digits: val,
                    amount: this.getMinimum("2upper"),
                    paybaht: this.calPayRate("2upper", val),
                  });
                  break;
                case "3upper":
                  this.lottoNumbersWithType.push({
                    type: "3shuffle",
                    digits: val,
                    amount: this.getMinimum("3shuffle"),
                    paybaht: this.calPayRate("3shuffle", val),
                  });
                  break;
                case "3shuffle":
                  this.lottoNumbersWithType.push({
                    type: "3upper",
                    digits: val,
                    amount: this.getMinimum("3upper"),
                    paybaht: this.calPayRate("3upper", val),
                  });
                  break;
                case "3back":
                  this.lottoNumbersWithType.push({
                    type: "3front",
                    digits: val,
                    amount: this.getMinimum("3front"),
                    paybaht: this.calPayRate("3front", val),
                  });
                  break;
                case "3front":
                  this.lottoNumbersWithType.push({
                    type: "3back",
                    digits: val,
                    amount: this.getMinimum("3back"),
                    paybaht: this.calPayRate("3back", val),
                  });
                  break;
              }
            } else {
              for (let i = 0; i < this.candidatesBetType.length; i++) {
                const bettype = this.candidatesBetType[i];
                const filters = this.lottoNumbersWithType.filter(
                  (e) => e.digits == val && e.type == bettype
                );

                if (filters.length <= 0) {
                  this.lottoNumbersWithType.push({
                    type: this.candidatesBetType[i],
                    digits: val,
                    amount: this.getMinimum(this.candidatesBetType[i]),
                    paybaht: this.calPayRate(this.candidatesBetType[i], val),
                  });
                }
              }
            }
          } else {
            for (let i = 0; i < this.candidatesBetType.length; i++) {
              const bettype = this.candidatesBetType[i];
              const filters = this.lottoNumbersWithType.filter(
                (e) => e.digits == val && e.type == bettype
              );
              switch (this.candidatesBetType[i]) {
                case "any_upper":
                  if (filters.length <= 0) {
                    this.lottoNumbersWithType.push({
                      type: "any_upper",
                      digits: val,
                      amount: this.getMinimum("any_upper"),
                      paybaht: this.calPayRate("any_upper", val),
                    });
                  } else {
                    const index = this.lottoNumbersWithType.findIndex(
                      (x) => x.type === "any_upper" && x.digits === val
                    );
                    this.lottoNumbersWithType.splice(index, 1);
                  }
                  break;
                case "any_under":
                  if (filters.length <= 0) {
                    this.lottoNumbersWithType.push({
                      type: "any_under",
                      digits: val,
                      amount: this.getMinimum("any_under"),
                      paybaht: this.calPayRate("any_under", val),
                    });
                  } else {
                    const index = this.lottoNumbersWithType.findIndex(
                      (x) => x.type === "any_under" && x.digits === val
                    );
                    this.lottoNumbersWithType.splice(index, 1);
                  }
                  break;
                case "2upper":
                  if (filters.length <= 0) {
                    this.lottoNumbersWithType.push({
                      type: "2upper",
                      digits: val,
                      amount: this.getMinimum("2upper"),
                      paybaht: this.calPayRate("2upper", val),
                    });
                  } else {
                    const index = this.lottoNumbersWithType.findIndex(
                      (x) => x.type === "2upper" && x.digits === val
                    );
                    this.lottoNumbersWithType.splice(index, 1);
                  }
                  break;
                case "2under":
                  if (filters.length <= 0) {
                    this.lottoNumbersWithType.push({
                      type: "2under",
                      digits: val,
                      amount: this.getMinimum("2under"),
                      paybaht: this.calPayRate("2under", val),
                    });
                  } else {
                    const index = this.lottoNumbersWithType.findIndex(
                      (x) => x.type === "2under" && x.digits === val
                    );
                    this.lottoNumbersWithType.splice(index, 1);
                  }
                  break;
                case "3upper":
                  if (filters.length <= 0) {
                    this.lottoNumbersWithType.push({
                      type: "3upper",
                      digits: val,
                      amount: this.getMinimum("3upper"),
                      paybaht: this.calPayRate("3upper", val),
                    });
                  } else {
                    const index = this.lottoNumbersWithType.findIndex(
                      (x) => x.type === "3upper" && x.digits === val
                    );
                    this.lottoNumbersWithType.splice(index, 1);
                  }
                  break;
                case "3shuffle":
                  if (filters.length <= 0) {
                    this.lottoNumbersWithType.push({
                      type: "3shuffle",
                      digits: val,
                      amount: this.getMinimum("3shuffle"),
                      paybaht: this.calPayRate("3shuffle", val),
                    });
                  } else {
                    const index = this.lottoNumbersWithType.findIndex(
                      (x) => x.type === "3shuffle" && x.digits === val
                    );
                    this.lottoNumbersWithType.splice(index, 1);
                  }
                  break;
                case "3back":
                  if (filters.length <= 0) {
                    this.lottoNumbersWithType.push({
                      type: "3back",
                      digits: val,
                      amount: this.getMinimum("3back"),
                      paybaht: this.calPayRate("3back", val),
                    });
                  } else {
                    const index = this.lottoNumbersWithType.findIndex(
                      (x) => x.type === "3back" && x.digits === val
                    );
                    this.lottoNumbersWithType.splice(index, 1);
                  }
                  break;
                case "3front":
                  if (filters.length <= 0) {
                    this.lottoNumbersWithType.push({
                      type: "3front",
                      digits: val,
                      amount: this.getMinimum("3front"),
                      paybaht: this.calPayRate("3front", val),
                    });
                  } else {
                    const index = this.lottoNumbersWithType.findIndex(
                      (x) => x.type === "3front" && x.digits === val
                    );
                    this.lottoNumbersWithType.splice(index, 1);
                  }
                  break;
              }
            }
          }
        }
      }
    },
    digitClickSet(val) {
      if (val) {
        const filters0 = this.lottoNumbersWithType.filter(
          (e) => e.digits == val && e.type == "4upper"
        );
        if (filters0.length <= 0) {
          this.lottoNumbersWithType.push({
            type: "4upper",
            digits: val,
            amount: this.getMinimum("4upper"),
            paybaht: 0,
          });
        } else {
          const index = this.lottoNumbersWithType.findIndex(
            (x) => x.type == "4upper" && x.digits == val
          );
          this.lottoNumbersWithType.splice(index, 1);
        }
      }
    },
    digitClickSpecial(val, betTypeSpecial, action) {
      if (action == "push") {
        const filters1 = this.lottoNumbersWithType.filter(
          (e) => e.digits == val && e.type == betTypeSpecial
        );
        if (filters1 <= 0) {
          this.lottoNumbersWithType.push({
            type: betTypeSpecial,
            digits: val,
            amount: this.getMinimum(betTypeSpecial),
            paybaht: this.calPayRate(betTypeSpecial, val),
          });
        }
      } else {
        const index1 = this.lottoNumbersWithType.findIndex(
          (x) => x.type === betTypeSpecial && x.digits === val
        );
        this.lottoNumbersWithType.splice(index1, 1);
      }
    },
    ShuffleDouble(val) {
      val = val.toString();
      val = val.split("");
      val = val.reverse();
      val = val.join("");
      return val;
    },

    statusUpdate(params) {      
      this.shootResult = params[1]==null?parseInt(params[0])-parseInt(params[4])+parseInt(params[5]):params[1];
      this.shootWinFirst = params[2];
      this.shootWinSecond = params[3];
      this.shootWinFirstDigit = params[4];
      this.shootWinSecondDigit = params[5];
    },

    provideBetOrShoot(item, index) {
      if (this.candidatesBetOrShoot.indexOf(index) == -1) {
        this.candidatesBetOrShoot.splice(
          this.candidatesBetOrShoot.indexOf(index),
          1
        );
        this.candidatesBetOrShoot.push(index);
        this.betOrShoot = index;
      }
    },

    containsBetOrShoot(arr, index) {
      return arr.indexOf(index) != -1;
    },

    provideButtonType(item, index) {
      if (this.candidatesButtonType.indexOf(index) == -1) {
        this.candidatesButtonType.splice(
          this.candidatesButtonType.indexOf(index),
          1
        );
        this.candidatesButtonType.push(index);
        this.buttonSelectType = index;
      }
    },

    containsButtonType(arr, index) {
      return arr.indexOf(index) != -1;
    },

    provideBetType(item, index, slug) {
      let currentBetType = "";

      if (slug.search("3back") != -1 || slug.search("3front") != -1) {
        currentBetType = "4";
      } else if (slug.search("3upper") != -1 || slug.search("3shuffle") != -1) {
        currentBetType = "3";
      } else if (slug.search("2") != -1) {
        currentBetType = "2";
      } else {
        currentBetType = "any";
      }

      if (this.betType != currentBetType) {
        this.candidatesBetType = [];
        this.candidatesBetType.push(slug);

        if (slug.search("3back") != -1 || slug.search("3front") != -1) {
          this.betType = "4";
        } else if (
          slug.search("3upper") != -1 ||
          slug.search("3shuffle") != -1
        ) {
          this.betType = "3";
        } else if (slug.search("2") != -1) {
          this.betType = "2";
        } else {
          this.betType = "any";
        }
      } else if (this.candidatesBetType.length >= 2) {
        if (this.candidatesBetType.indexOf(slug) == -1) {
          this.candidatesBetType = [];
          this.candidatesBetType.push(slug);

          if (slug.search("3back") != -1 || slug.search("3front") != -1) {
            this.betType = "4";
          } else if (
            slug.search("3upper") != -1 ||
            slug.search("3shuffle") != -1
          ) {
            this.betType = "3";
          } else if (slug.search("2") != -1) {
            this.betType = "2";
          } else {
            this.betType = "any";
          }
        } else {
          this.candidatesBetType.splice(
            this.candidatesBetType.indexOf(slug),
            1
          );
        }
      } else if (this.candidatesBetType.indexOf(slug) == -1) {
        this.candidatesBetType.push(slug);
        if (slug.search("3back") != -1 || slug.search("3front") != -1) {
          this.betType = "4";
        } else if (
          slug.search("3upper") != -1 ||
          slug.search("3shuffle") != -1
        ) {
          this.betType = "3";
        } else if (slug.search("2") != -1) {
          this.betType = "2";
        } else {
          this.betType = "any";
        }
      } else {
        this.candidatesBetType.splice(this.candidatesBetType.indexOf(slug), 1);
      }
    },

    containsBetType(arr, item) {
      return arr.indexOf(item) != -1;
    },

    getRateKey(data) {
      self = this;
      for (let i = 0; i < data.length; i++) {
        if (data[i][1].special_rate.length > 0) {
          for (let sp = 0; sp < data[i][1].special_rate.length; sp++) {
            this.specialRate.push({
              type: data[i][1].slug,
              digit: data[i][1].special_rate[sp].digits,
              pay_baht: data[i][1].special_rate[sp].rate_baht,
              pay_percent: data[i][1].special_rate[sp].rate_percent,
              pay_type: data[i][1].special_rate[sp].type,
            });
          }
        }
        const index = this.acceptants.findIndex(
          (x) => x.slug === data[i][1].slug
        );
        this.acceptants[index].default_pay_rate = data[i][1].default_pay_rate;
      }
      this.accepTantsTemp = this.acceptants;
    },
    calPayRate(type, digit) {
      const results = this.specialRate.filter(
        (i) => i.digit == digit && i.type == type
      );
      const results2 = this.accepTantsTemp.filter((sp) => sp.slug == type);
      if (results.length > 0) {
        const bonusRate = this.specialRate.filter(
          (i) =>
            i.digit == digit && i.pay_type == "special" && i.pay_percent > 100
        );

        if (bonusRate.length > 0) {
          return (
            (results2[0].default_pay_rate * bonusRate[0].pay_percent) / 100
          );
        }
        return results[0].pay_baht;
      }

      return results2[0].default_pay_rate;
    },
  },
};
</script>
